﻿$('.dropdown-menu a.dropdown-toggle').on('click', function (e) {

    if ($(this).closest('.mobile-device-menu').length) {
        return; // Exit if inside .mobile-device-menu
    }

    if (!$(this).next().hasClass('show')) {
        $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
    }
    var $subMenu = $(this).next('.dropdown-menu');
    $subMenu.toggleClass('show');


    $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
        $('.dropdown-submenu .show').removeClass('show');
    });


    return false;
});

$("#priceModal").on("show.bs.modal", function (event) {
    var trigger = $(event.relatedTarget);
    var houseTitle = trigger.data("house-title")
    if (houseTitle) {
        $(this).find(".modal-title").html(houseTitle);
    }

    var houseDomain = trigger.data("house-domain") || "";
    var houseEncryptedData = trigger.data("encryptedhousedata") || "";
    var bookhusToken = "";
    if (houseEncryptedData && houseEncryptedData.length > 0) {
        bookhusToken = '?bookhusToken=' + encodeURIComponent(houseEncryptedData);
    }
    
    var body = $(this).find(".modal-body");
    body.html('<p><img src="/Content/siteimages/loadericons/small-blue.gif" alt="Indlæser"/></p>');
    body.load(houseDomain + "/PriceList/PartialPriceList/" + trigger.data("house-id") + bookhusToken);
});

var displayDialog = true;
$("[data-target^='#mapsdr']").on('click', function (e) {
    e.preventDefault();
    var $btn = $(e.target);

    if ($btn.data('userAddressLoaded')) {
        return;
    }

    if ($btn.data('userinput') && !displayDialog) {
        displayDialog = true;
        return;
    }
    e.stopPropagation();
    if ($btn.data('userinput')) {
        displayInputDialog($btn.data('userinput')).then(function (result) {
            if (result.isConfirmed) {
                userInput = {
                    Address: result.value[0],
                    Zipcode: result.value[1],
                    City: result.value[2]
                };

                var url = $btn.data('basehref');
                url += '&adresse=' + encodeURIComponent(userInput.Address) + '&zipcode=' + encodeURIComponent(userInput.Zipcode) + '&city=' + encodeURIComponent(userInput.City);
                $btn.prop('href', url);
                $btn.data('userinput', userInput);
                displayDialog = false;
                $btn.trigger('click');
            }
        });
        return;
    }

    $.getJSON('/account/address', function (result) {
        if (!result || !result.Address || !result.Zipcode || !result.City) {
            displayInputDialog(result).then(function (result) {
                if (result.isConfirmed) {
                    userInput = {
                        Address: result.value[0],
                        Zipcode: result.value[1],
                        City: result.value[2]
                    };

                    var url = $btn.data('basehref');
                    url += '&adresse=' + encodeURIComponent(userInput.Address) + '&zipcode=' + encodeURIComponent(userInput.Zipcode) + '&city=' + encodeURIComponent(userInput.City);
                    $btn.prop('href', url);
                    $btn.data('userinput', userInput);
                    displayDialog = false;
                    $btn.trigger('click');
                }
            });
        }
        else {
            var url = $btn.data('basehref');
            url += '&adresse=' + encodeURIComponent(result.Address) + '&zipcode=' + encodeURIComponent(result.Zipcode) + '&city=' + encodeURIComponent(result.City);
            $btn.prop('href', url);
            $btn.data('userAddressLoaded', true);
            $btn.trigger('click');
        }
    });
});

function displayInputDialog(input) {
    return swal.fire({
        title: window.Bookhus.Localization.Standard.UI.Widgets.DialogBox.EnterAddressInformation,
        text: window.Bookhus.Localization.Standard.UI.Widgets.DialogBox.EnterMissingAddressInformation,
        html:
            '<label>' + window.Bookhus.Localization.Standard.Userprofile.Address + '</label><br/><input id="swal-input1" class="swal2-input"><br/>' +
            '<label>' + window.Bookhus.Localization.Standard.Userprofile.Zipcode + '</label><br/><input id="swal-input2" class="swal2-input"><br/>' +
            '<label>' + window.Bookhus.Localization.Standard.Userprofile.City + '</label><br/><input id="swal-input3" class="swal2-input">',
        preConfirm: function () {
            return new Promise(function (resolve) {
                resolve([
                    $('#swal-input1').val(),
                    $('#swal-input2').val(),
                    $('#swal-input3').val()
                ]);
            });
        },
        onOpen: function () {
            $('#swal-input1').focus();

            $('#swal-input1').val(input.Address || '');
            $('#swal-input2').val(input.Zipcode || '');
            $('#swal-input3').val(input.City || '');
        },
        showCancelButton: true,
        cancelButtonText: window.Bookhus.Localization.Standard.UI.ButtonText.Cancel,
        confirmButtonText: window.Bookhus.Localization.Standard.UI.ButtonText.Ok
    });
}

$('.mapspopup').each(function () {
    $(this).on("show.bs.modal", function (e) {
        $('#mymap').remove();

        var link = $(e.relatedTarget);
        //$(this).find(".modal-body").html('<div id="mymap" style="background:#aadddd; width:500px; height:500px;"></div>');
        $(this).find(".modal-body").load(link.attr("href"), function () {

            if (typeof window.calcRoute_mymap === "function") {
                $('.modal-dialog').css('width', '860px');
                $('#mymap_directions').css('line-height', 'normal');
                $('#mymap_directions').css('background', 'transparent');
                window.calcRoute_mymap();
            } else {
                $('.modal-dialog').css('width', '80%');
                $('#mymap').css('width', '100%');
            }
        });
    });
    $(this).on('shown.bs.modal', function () {
        if (typeof window.initializeGoogleMaps_mymap === "function") {
            window.initializeGoogleMaps_mymap();
            window.initializeGoogleMaps_mymap = null;
        }
        if (typeof window.calcRoute_mymap === "function") {
            window.calcRoute_mymap();
            window.calcRoute_mymap = null;

        }
    });
});

$("#printDriveDirections").on('click', function () {
    $("[id^='mapsdr']").modal('hide');

    var prtContent = document.getElementById("mymap_directions");
    if (prtContent) {

        var iframe = document.getElementById('printArea');
        if (!iframe) {
            iframe = document.createElement('iframe');
            iframe.id = "printArea";
            iframe.hidden = true;
            document.body.appendChild(iframe);
        }
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(prtContent.innerHTML);
        iframe.contentWindow.document.close();
        iframe.contentWindow.window.print();
    } else {
        swal.fire({
            title: window.Bookhus.Localization.Standard.UI.GeneralText.Error,
            text: window.Bookhus.Localization.Standard.UI.Widgets.DialogBox.NoDrivingInstructionsFound,
            icon: 'error',
            confirmButtonText: window.Bookhus.Localization.Standard.UI.ButtonText.Ok
        });
    }
});

$(document).ready(function () {
    //if (!window.disableScroll) {
    //    window.scroll({
    //        top: 0,
    //        left: 0,
    //        behavior: 'smooth'
    //    });
    //}

    $('.selectItem').on("change", "input", function () {
        if ($(this).is(':checked')) {
            $(this).parents('.card').addClass('selected')
        } else {
            $(this).parents('.card').removeClass('selected')
        }
    });

    $('.viewMoreBtn').click(function () {
        $(this).parents('.viewMoreFilters').toggleClass('open');
        return false;
    });

    $('.toggleBtn').click(function () {
        $($(this).attr('href')).toggleClass('active');
        return false;
    })
    $("#checkIn").datepicker({
        changeMonth: true,
        changeYear: true
    });

    // $('.blogSection .carousel .carousel-item, .threeColSlider .carousel .carousel-item').each(function(){
    //     var minPerSlide = 3;
    //     var next = $(this).next();
    //     if (!next.length) {
    //         next = $(this).siblings(':first');
    //     }
    //     next.children(':first-child').clone().appendTo($(this));

    //     for (var i=0;i<minPerSlide;i++) {
    //         next=next.next();
    //         if (!next.length) {
    //            next = $(this).siblings(':first');
    //        }

    //        next.children(':first-child').clone().appendTo($(this));
    //    }
    //});

})